<template>
    <div>
        <div class="custom-modal show-custom-modal force-phone-modal" :class="{ 'low-height' : requireNewsletter && !requirePhone && !newCustomer }" v-if="showModal">
            <div class="custom-modal-window">

                <div class="custom-modal-body">

                    <div class="container-fluid" v-if="!savedSuccess">

                        <div v-if="requireNewsletter && !requirePhone && !newCustomer">

                        </div>

                        <div class="mb-4" v-else-if="requirePhone && !newCustomer">
                            <h1>Vänligen ange ditt mobilnummer</h1>
                            <p>Vi använder SMS som huvudsaklig kommunikation till dig som kund.</p>
                        </div>

                        <div v-else>

                            <div class="text-center">
                                <img class="mb-4" style="width:65%; max-width: 260px;" src="/images/card/search-message-illustration-new1.svg?d=20211103">
                            </div>

                            <h1 style="font-size: calc(1.3rem + 1.5vw);">Välkommen till Hälsoresurs</h1>
                            <p style="margin-bottom: 16px;">Här söker du efter massörer och bokar massage. Det är också här som massören registrerar din behandling efter att den utförts.</p>

                            <p v-if="requirePhone"><span style="font-weight: 500;">Vänligen ange ditt mobilnummer</span><br>Vi använder SMS som huvudsaklig kommunikation till dig som kund.</p>

                        </div>

                    </div>

                    <div class="custom-register-container">

                        <div class="custom-step step1">

                            <div class="container-fluid" v-if="!savedSuccess">

                                <form action="#" @submit.prevent="triggerPatch">

                                    <div v-if="requirePhone">
                                        <input-text
                                            type="phone"
                                            name="phone"
                                            placeholder="Ditt mobilnummer"
                                            v-model="phone"
                                            :inputClass="phoneInputClasses"
                                            autocorrect="off"
                                            autocomplete="off"
                                        />

                                        <div style="display:none;" :class="{'d-block': former.errors.phone }">

                                            <div class="text-danger" v-if="former.errors.phone && former.errors.phone[0] === 'required'">Vänligen ange ditt mobilnummer</div>

                                            <div v-if="former.errors.phone && former.errors.phone[0] === 'phone'" class="mt-4">
                                                <h3 class="text-warning">Vänligen ange ett korrekt mobilnummer</h3>
                                                <p>Kontrollera numret och försök igen. Har du inte ett svenskt mobilnummer? Kontakta vår support på <a href="mailto:info@halsoresurs.se">info@halsoresurs.se</a> så hjälper vi dig.</p>
                                            </div>

                                            <div v-if="former.errors.phone && former.errors.phone[0] === 'unique'" class="mt-4">
                                                <h3 class="text-warning">Ditt mobilnummer finns redan i vårt system</h3>
                                                <p>Kontakta vår support på <a href="mailto:info@halsoresurs.se">info@halsoresurs.se</a> så hjälper vi dig.</p>
                                            </div>

                                        </div>
                                    </div>

                                    <div class="mb-3" v-if="requireNewsletter">
                                        <p class="pt-4" style="font-weight: 500;">Vill du ta emot erbjudanden och utskick från Hälsoresurs? <a href="https://halsoresurs.se/integritetspolicy/" target="_blank">Vår integritetspolicy.</a></p>

                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="newsletter" id="newsletter-yes" :value="true" v-model="newsletter">
                                            <label class="form-check-label" for="newsletter-yes">Ja tack</label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="newsletter" id="newsletter-no" :value="false" v-model="newsletter">
                                            <label class="form-check-label" for="newsletter-no">Nej tack</label>
                                        </div>

                                        <div v-if="former.errors.newsletter" class="text-danger mt-4">
                                            Vänligen svara Ja eller Nej
                                        </div>

                                    </div>

                                    <button class="btn btn-primary w-100 mt-4" :disabled="patcher.submitted">
                                        Spara och fortsätt
                                    </button>

                                </form>

                            </div>

                            <div class="container-fluid">

                                <div class="w-100 text-center check-confirm" :class="{ 'show' : savedSuccess }">
                                    <img src="https://halsoresurs.se/wp-content/themes/halsoresurs-2023/public/images/check.svg">
                                    <h1 v-if="!requirePhone && requireNewsletter">Tack för ditt svar!</h1>
                                    <h1 v-else>Tack, ditt nummer är sparat!</h1>
                                </div>

                            </div>

                        </div>

                        <div class="spinner" v-if="patcher.submitted"></div>

                    </div>

                </div>

            </div>
        </div>
        <div class="add-to-home-screen-bg active" style="z-index: 3999;" v-if="showModal"></div>
    </div>
</template>

<script>
import modaler from '../../../shared/mixins/modaler'
import fetcher from '../../../shared/mixins/fetcher'
import patcher from '../../../shared/mixins/patcher'
import jQuery from 'jquery'

export default {

    mixins: [
        modaler,
        fetcher,
        patcher
    ],

    data () {
        return {
            phone: '',
            newsletter: null,
            validation_error: false,
            showModal: false,
            requirePhone: false,
            requireNewsletter: false,
            newCustomer: false,
            savedSuccess: false,

            fetcher: {
                autoFill: ['showModal', 'requirePhone', 'requireNewsletter', 'newCustomer']
            }
        }
    },

    computed: {

        fetcherUrl () {
            return '/checkPhone'
        },

        patcherUrl () {
            return '/setPhone'
        },

        patcherData () {
            return {
                phone: this.phone,
                newsletter: this.newsletter,
                requirePhone: this.requirePhone,
                requireNewsletter: this.requireNewsletter
            }
        },

        phoneInputClasses () {
            let classes = 'form-border text-center'
            if (this.validation_error) {
                classes += ' is-invalid'
            }
            return classes
        }

    },

    watch: {
        showModal () {
            this.$emit('showModal', this.showModal)
        }
    },

    methods: {

        fetcherSuccess (data) {
            if (this.showModal == false) {
                jQuery('html').removeClass('modal-open')
            }
        },

        triggerPatch () {
            document.activeElement.blur()
            this.patcherPatch()
        },

        patcherSuccess (data) {
            this.validation_error = false

            this.savedSuccess = true

            const self = this
            setTimeout(function () {
                self.showModal = false
                self.closeCustomModal()
                const scrollToPosition = 0
                jQuery('html, body').stop().animate({ scrollTop: scrollToPosition + 'px' }, 250)
            }, 2500)
        },

        patcherFail (response) {
            console.log('patcherFail response')
            console.log(response)

            if (!this.treatment_token && (response.data.errormess || response.data.message)) {
                this.validation_error = response.data.errormess ?? response.data.message
            }
        }

    }
}
</script>
